import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./services/auth/auth.guard";
import { ProjectGuard } from "./services/project-cart/project.guard";


const routes: Routes = [
    {
     path: '',
     redirectTo: 'login',
     pathMatch: 'full'

    },
    {
        // The first screen after login: single configuration, or a project.
        // Everything downstream assumes a project exists, hence ProjectGuard.
        path: 'mode',
        loadChildren: () => import('./components/mode-select/mode-select.module').then(m => m.ModeSelectModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'lines',
        loadChildren: () => import('./components/lines/lines.module').then(m => m.LinesModule),
        canActivate: [AuthGuard, ProjectGuard]

    },
    {
        path: 'home',
        loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule),
        canActivate: [AuthGuard, ProjectGuard]

    },
    {
        path: 'login',
        loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule),

    },
    {
        path: 'cart',
        loadChildren: () => import('./components/cart/cart.module').then(m => m.CartModule),
        canActivate: [AuthGuard, ProjectGuard]
    },
    {
        path: 'checkout',
        loadChildren: () => import('./components/checkout/checkout.module').then(m => m.CheckoutModule),
        canActivate: [AuthGuard, ProjectGuard]
    },
    {
        path : 'order-details',
        loadChildren: () => import('./components/order-details/order-details.module').then(m => m.OrderDetailsModule),
        canActivate: [AuthGuard, ProjectGuard]
    },
    {
      // Deliberately not project-guarded: this opens in a separate tab and
      // renders from its own storage/API payload.
      path : 'pdf',
      loadChildren: () => import('./shared/pdf-generator/pdf-generator.module').then(m => m.PDFGeneratorModule),
      canActivate: [AuthGuard]
  }


]

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
  })
  export class AppRoutingModule { }
